import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container,
} from '@mui/material';
import {
  CancelOutlined,
  ArrowBackOutlined,
  HomeOutlined,
} from '@mui/icons-material';

const SubscriptionCancelPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper
        elevation={6}
        sx={{
          p: { xs: 4, sm: 6 },
          borderRadius: 3,
          textAlign: 'center',
          background: 'linear-gradient(145deg, #ffffff 0%, #F9FAFB 100%)',
          border: '2px solid #F59E0B',
        }}
      >
        {/* Icône d'annulation */}
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            bgcolor: '#F59E0B',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            mb: 3,
          }}
        >
          <CancelOutlined sx={{ fontSize: 60, color: 'white' }} />
        </Box>

        {/* Titre */}
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: '#374151',
            mb: 2,
          }}
        >
          Paiement annulé
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: '#6B7280',
            mb: 4,
          }}
        >
          Aucun paiement n'a été effectué
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#374151',
            mb: 4,
          }}
        >
          Vous avez annulé le processus de paiement. Vous pouvez réessayer à tout moment pour bénéficier de toutes les fonctionnalités premium de Sersal.
        </Typography>

        {/* Boutons */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            variant="outlined"
            size="large"
            startIcon={<HomeOutlined />}
            onClick={() => navigate('/dashboard')}
            sx={{
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              fontWeight: 600,
              color: '#374151',
              borderColor: '#374151',
              '&:hover': {
                borderColor: '#1F2937',
                bgcolor: '#F9FAFB',
              },
            }}
          >
            Retour à l'accueil
          </Button>

          <Button
            variant="contained"
            size="large"
            startIcon={<ArrowBackOutlined />}
            onClick={() => navigate('/subscription')}
            sx={{
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              fontWeight: 700,
              bgcolor: '#F59E0B',
              color: 'white',
              '&:hover': {
                bgcolor: '#D97706',
              },
            }}
          >
            Voir l'abonnement
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SubscriptionCancelPage;
